import { render, staticRenderFns } from "./point-list.vue?vue&type=template&id=78a6e7f7&scoped=true"
import script from "./point-list.vue?vue&type=script&lang=js"
export * from "./point-list.vue?vue&type=script&lang=js"
import style0 from "./point-list.vue?vue&type=style&index=0&id=78a6e7f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a6e7f7",
  null
  
)

export default component.exports